import React from "react";
import { useNavigate } from "react-router-dom";

export default function BottomNav() {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      <button style={styles.btn} onClick={() => navigate("/home")}>Home</button>
      <button style={styles.btn} onClick={() => navigate("/dashboard")}>Dashboard</button>
      <button style={styles.btn} onClick={() => navigate("/history")}>History</button>
      <button style={styles.btn} onClick={() => navigate("/profile")}>Profile</button>
      <button style={styles.btn} onClick={() => navigate("/about")}>About</button>
      <button style={styles.btn} onClick={() => navigate("/contact")}>Contact</button>
    </div>
  );
}

const styles = {
  navbar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    background: "rgba(0,0,0,0)", 
    display: "flex",
    justifyContent: "space-around",
    padding: "12px 0",
    backdropFilter: "blur(3px)",
    zIndex: 1000,
  },

  btn: {
    border: "1px solid #7dff57",          // 🌟 Green border added
    borderRadius: "10px",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "600",
    padding: "6px 12px",
    cursor: "pointer",
    boxShadow: "0 0 10px rgba(125,255,87,0.45)", // 🌟 Green glow shadow added
    transition: "0.25s ease",
  }
};

/* HOVER EFFECT */
setTimeout(() => {
  const sheet = document.styleSheets[0];
  sheet.insertRule(`
    button[style*="cursor: pointer"]:hover {
      color: #e3ffcf;
      transform: scale(1.1);
      text-shadow: 0 0 10px rgba(180,255,143,0.9);
      box-shadow: 0 0 14px rgba(125,255,87,0.85); /* stronger glow */
    }
  `, sheet.cssRules.length);
}, 50);
